export const handleClearCache = async () => {
    try {
        try {
            localStorage.clear();
        } catch (e) {
            console.warn('Failed to clear localStorage:', e);
        }

        try {
            sessionStorage.clear();
        } catch (e) {
            console.warn('Failed to clear sessionStorage:', e);
        }

        if ('caches' in window) {
            try {
                const cacheNames = await caches.keys();
                await Promise.allSettled(
                    cacheNames.map((name) => caches.delete(name)),
                );
            } catch (e) {
                console.warn('Failed to clear caches:', e);
            }
        }

        if ('serviceWorker' in navigator) {
            try {
                const registrations =
                    await navigator.serviceWorker.getRegistrations();
                await Promise.allSettled(
                    registrations.map((reg) => reg.unregister()),
                );
            } catch (e) {
                console.warn('Failed to unregister service workers:', e);
            }
        }
    } catch (err) {
        console.error('Unexpected error during cache clear:', err);
    } finally {
        window.location.reload(true);
    }
};
